import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {boolean} props.borderRadius - Is border radius needed (true or false)
 * @param {boolean} props.borderRadiusTopRight - Is border radius top right needed (true or false) (if you pass true to borderRadius, then one of the position is compulsory )
 * @param {boolean} props.borderRadiusBottomLeft - Is border radius bottom left needed (true or false)  (if you pass true to borderRadius, then one of the position is compulsory )
 * @param {String} props.icon - Takes svg as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {boolean} props.heightFullRequired - If you want to take button height of parent div then pass, ( "true" else it will be false )
 * @returns {JSX.Element}
 */
const TertiaryButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  borderRadius,
  borderRadiusTopRight,
  borderRadiusBottomLeft,
  icon,
  hoverOption,
  buttonRef,
  heightFullRequired,
  imgColor,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center py-padding-sm px-padding-button-l ${borderRadiusTopRight ? "w-auto max-w-tertiary-btn-width" : "w-tertiary-btn-width"} ${heightFullRequired ? "h-height-full " : "h-tertiary-btn-height "}  ${
        borderRadius && borderRadiusTopRight
          ? "rounded-tr-border-radius-md"
          : borderRadius && borderRadiusBottomLeft
            ? "rounded-bl-border-radius-md"
            : ""
      } cursor-${
        isDisabled
          ? "not-allowed opacity-light-opacity "
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : "global-hover-black"
            }`
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      <div
        className={`w-full flex flex-row items-center justify-between ${borderRadiusTopRight ? "gap-gap-sm" : "gap-gap-button-l"}`}
      >
        <div
          className={
            "flex justify-center items-center text-font-xs font-semibold wrap-break-word"
          }
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
        {icon ? (
          <SvgComponent
            color={imgColor}
            height="var(--icon-sm)"
            width="var(--icon-sm)"
            url={icon}
            alt="Icon"
          />
        ) : null}
      </div>
    </button>
  );
};

export default TertiaryButton;
